import { AuthedAxiosRequests } from 'features/auth'

export const triggerInspectionEditPipeline = async (
  slug: string,
  conduitApiUrl: string,
  axios: AuthedAxiosRequests
) => {
  return await axios.post(
    `${conduitApiUrl}/api/v1/inspections/${slug}/inspection-config`,
    undefined,
    { headers: { 'Content-Type': 'application/json' } }
  )
}
